import React from 'react';
import './Image.css';

const image = (props) => (
    <div className="Image"></div>
)

export default image;